import { Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { DocumentEntry } from '../../../api/app-types/document.app';
import { CommonTemplate } from '../../../api/api-types/document.api';

@Component({
	selector: 'lvr-document-item',
	imports: [MatIcon],
	templateUrl: './document-item.html',
	styleUrl: './document-item.scss',
})
export class LvrDocumentItem {
	public readonly document = input.required<DocumentEntry | CommonTemplate>();
	public readonly open = output<DocumentEntry | CommonTemplate>();

	public isDocumentEntry(item: DocumentEntry | CommonTemplate): item is DocumentEntry {
		return 'externalFileReference' in item;
	}

	public onOpen() {
		this.open.emit(this.document());
	}

	public onKeydown(event: KeyboardEvent) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			this.onOpen();
		}
	}
}
